import { useContext, useEffect } from 'react';
import ProjectProgressionContext from '../../state/context';
import { INSIGHTS_KEYS } from '../../Insights/insights.keys';
import { PROGRESSION_CHILD_MODEL } from './table-layouts/model';

const mapInsightKeyToSortByKey = {
  [INSIGHTS_KEYS.CONTEXT_SWITCH]: PROGRESSION_CHILD_MODEL.ASSIGNEE
};

const useInsightsSortBy = ({ tableSortBy, tableType }) => {
  const {
    state: { selectedInsightKey }
  } = useContext(ProjectProgressionContext);

  const onInsightChange = () => {
    if (tableType.level !== 0) return;

    const sortByKey = mapInsightKeyToSortByKey[selectedInsightKey];
    const supportedSortableCols = tableType.sortBy.supportedCols;
    if (!!sortByKey && supportedSortableCols.includes(sortByKey)) {
      tableSortBy.onChange(sortByKey);
    }
  };

  useEffect(() => {
    onInsightChange();
  }, [selectedInsightKey, tableType]);
};

export default useInsightsSortBy;
